/** Canonical design boards home. */
export const DESIGN_BOARDS_URL = '/app/boards';

export interface BoardUrlParts {
    urlSegment?: string;
    projectUrlSegment?: string;
    isPersonal?: boolean;
}

/**
 * Canonical page for a board: personal boards live under /app/boards, project
 * boards under their BuildHub. Undefined when the slug is unknown, so callers
 * decide their own fallback (the gate goes to the boards home, the popover
 * toast drops its "View board" action).
 */
export const resolveBoardUrl = (
    board?: BoardUrlParts | null,
): string | undefined => {
    if (!board?.urlSegment) {
        return undefined;
    }
    if (!board.isPersonal && board.projectUrlSegment) {
        return `/app/project/${board.projectUrlSegment}/boards/${board.urlSegment}`;
    }
    return `${DESIGN_BOARDS_URL}/${board.urlSegment}`;
};
